import {
  getWorkspaceGovernanceRoutePermissions,
} from '../../shared/governance/workspaceGovernancePolicy';
import { AI_PERMISSION_KEYS } from '../../shared/auth/aiPermissions';

const FIELD_CONTROLLER_PERMISSIONS = getWorkspaceGovernanceRoutePermissions('fieldController');
const CUSTOM_FIELD_PERMISSIONS = getWorkspaceGovernanceRoutePermissions('customFields');
const DOCUMENT_FORM_LAYOUT_PERMISSIONS = getWorkspaceGovernanceRoutePermissions('documentFormLayouts');
const CAMPAIGN_PERMISSIONS = getWorkspaceGovernanceRoutePermissions('campaigns');
const ACTIVITY_HISTORY_PERMISSIONS = getWorkspaceGovernanceRoutePermissions('auditLogs');
const KEYBOARD_MODE_PERMISSIONS = ['keyboardMode:use'];

export const standardRouteDefs = [
  { path: '/dashboard', key: 'dashboard', feature: 'dashboard', permissionsAny: ['dashboard:read'] },
  { path: '/activity-history', key: 'activityHistory', feature: 'auditLogs', permissionsAny: ACTIVITY_HISTORY_PERMISSIONS },
  { path: '/campaigns', key: 'campaigns', feature: 'campaigns', permissionsAny: CAMPAIGN_PERMISSIONS },
  {
    path: '/ai-studio/campaigns',
    key: 'aiStudioCampaigns',
    feature: 'aiStudio',
    permissionsAny: ['campaigns:manage'],
    permissionsAll: [AI_PERMISSION_KEYS.campaignStudio],
  },
  {
    path: '/ai-studio/sales-documents',
    key: 'aiStudioSalesDocuments',
    feature: 'aiStudio',
    permissionsAny: ['invoices:write', 'estimatedInvoices:write', 'quotations:write'],
    permissionsAll: [AI_PERMISSION_KEYS.salesDocumentStudio],
  },
  {
    path: '/ai-studio/document-studio',
    key: 'aiStudioDocumentStudio',
    feature: 'aiStudio',
    permissionsAny: ['documentLayouts:manage', 'customFields:manage', 'documentFormLayouts:edit'],
    permissionsAll: [AI_PERMISSION_KEYS.documentStudio],
  },
  { path: '/invoices', key: 'invoiceList', feature: 'invoices', permissionsAny: ['invoices:read', 'invoices:write'] },
  { path: '/invoices/new', key: 'invoiceForm', feature: 'invoices', permissionsAny: ['invoices:write'] },
  { path: '/invoices/edit/:id', key: 'invoiceForm', feature: 'invoices', permissionsAny: ['invoices:write'] },
  { path: '/invoices/view/:id', key: 'invoiceView', feature: 'invoices', permissionsAny: ['invoices:read', 'invoices:write'] },
  { path: '/quotations', key: 'quotationList', feature: 'quotations', permissionsAny: ['quotations:read', 'quotations:write'] },
  { path: '/quotations/new', key: 'quotationForm', feature: 'quotations', permissionsAny: ['quotations:write'] },
  { path: '/quotations/edit/:id', key: 'quotationForm', feature: 'quotations', permissionsAny: ['quotations:write'] },
  { path: '/quotations/view/:id', key: 'quotationView', feature: 'quotations', permissionsAny: ['quotations:read', 'quotations:write'] },
  { path: '/estimated-invoices', key: 'estimatedInvoiceList', feature: 'estimatedInvoices', permissionsAny: ['estimatedInvoices:read', 'estimatedInvoices:write'] },
  { path: '/estimated-invoices/new', key: 'estimatedInvoiceForm', feature: 'estimatedInvoices', permissionsAny: ['estimatedInvoices:write'] },
  { path: '/estimated-invoices/edit/:id', key: 'estimatedInvoiceForm', feature: 'estimatedInvoices', permissionsAny: ['estimatedInvoices:write'] },
  { path: '/estimated-invoices/view/:id', key: 'estimatedInvoiceView', feature: 'estimatedInvoices', permissionsAny: ['estimatedInvoices:read', 'estimatedInvoices:write'] },
  { path: '/products', key: 'products', feature: 'products', permissionsAny: ['products:read', 'products:write'] },
  { path: '/customers', key: 'customers', feature: 'customers', permissionsAny: ['customers:read', 'customers:write'] },
  { path: '/taxes', key: 'taxes', feature: 'taxes', permissionsAny: ['taxes:read', 'taxes:write'] },
  { path: '/document-templates', key: 'documentLayouts', feature: 'documentLayouts', permissionsAny: ['documentLayouts:read', 'documentLayouts:manage'] },
  { path: '/document-form-layouts', key: 'documentFormLayouts', feature: 'documentFormLayouts', permissionsAny: DOCUMENT_FORM_LAYOUT_PERMISSIONS },
  { path: '/settings', key: 'settings', feature: 'settings', permissionsAny: ['settings:read', 'settings:manage'] },
  {
    path: '/settings/admin',
    key: 'settingsAdmin',
    feature: 'settings',
    permissionsAny: ['tenantUsers:read', 'tenantUsers:manage'],
  },
  {
    path: '/settings/fields',
    key: 'fieldController',
    feature: 'fieldController',
    permissionsAny: FIELD_CONTROLLER_PERMISSIONS,
  },
  {
    path: '/settings/custom-fields',
    key: 'customFields',
    feature: 'customFields',
    permissionsAny: CUSTOM_FIELD_PERMISSIONS,
  },
  { path: '/ledger', key: 'ledger', feature: 'ledger', permissionsAny: ['ledger:read'] },
  { path: '/admin', key: 'adminConsole', sessionScope: 'admin' },
  { path: '/admin/bugs', key: 'adminBugs', sessionScope: 'admin' },
  { path: '/customer-portal', key: 'customerPortalHome', sessionScope: 'customer', feature: 'customerPortal' },
  {
    path: '/customer-portal/documents',
    key: 'customerPortalDocuments',
    sessionScope: 'customer',
    feature: 'customerPortal',
  },
  {
    path: '/customer-portal/documents/:type/:id',
    key: 'customerPortalDocumentDetail',
    sessionScope: 'customer',
    feature: 'customerPortal',
  },
  { path: '/customer-portal/planner', key: 'customerPortalPlanner', sessionScope: 'customer', feature: 'customerPortal' },
];

export const keyboardRouteDefs = [
  { path: '/', key: 'mainMenu', permissionsAll: KEYBOARD_MODE_PERMISSIONS },
  { path: '/:pageName', key: 'pageShell', permissionsAll: KEYBOARD_MODE_PERMISSIONS },
  {
    path: '/campaigns',
    key: 'keyboardCampaigns',
    feature: 'campaigns',
    permissionsAny: CAMPAIGN_PERMISSIONS,
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/settings',
    key: 'keyboardSettings',
    feature: 'settings',
    permissionsAny: ['settings:read', 'settings:manage'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/settings/fields',
    key: 'keyboardFieldController',
    feature: 'fieldController',
    permissionsAny: FIELD_CONTROLLER_PERMISSIONS,
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/settings/custom-fields',
    key: 'keyboardCustomFields',
    feature: 'customFields',
    permissionsAny: CUSTOM_FIELD_PERMISSIONS,
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/taxes',
    key: 'keyboardTaxes',
    feature: 'taxes',
    permissionsAny: ['taxes:read', 'taxes:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/customers',
    key: 'keyboardCustomers',
    feature: 'customers',
    permissionsAny: ['customers:read', 'customers:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/product',
    key: 'keyboardProducts',
    feature: 'products',
    permissionsAny: ['products:read', 'products:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/ledger',
    key: 'keyboardLedger',
    feature: 'ledger',
    permissionsAny: ['ledger:read'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/invoices',
    key: 'keyboardInvoiceList',
    feature: 'invoices',
    permissionsAny: ['invoices:read', 'invoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/invoices/new',
    key: 'keyboardInvoiceForm',
    feature: 'invoices',
    permissionsAny: ['invoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/invoices/edit/:id',
    key: 'keyboardInvoiceForm',
    feature: 'invoices',
    permissionsAny: ['invoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/invoices/view/:id',
    key: 'keyboardInvoiceView',
    feature: 'invoices',
    permissionsAny: ['invoices:read', 'invoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/invoices/:invoiceId/actions',
    key: 'keyboardInvoiceActions',
    feature: 'invoices',
    permissionsAny: ['invoices:read', 'invoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/quotations',
    key: 'keyboardQuotationList',
    feature: 'quotations',
    permissionsAny: ['quotations:read', 'quotations:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/quotations/new',
    key: 'keyboardQuotationForm',
    feature: 'quotations',
    permissionsAny: ['quotations:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/quotations/edit/:id',
    key: 'keyboardQuotationForm',
    feature: 'quotations',
    permissionsAny: ['quotations:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/quotations/view/:id',
    key: 'keyboardQuotationView',
    feature: 'quotations',
    permissionsAny: ['quotations:read', 'quotations:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/estimated-invoices',
    key: 'keyboardEstimatedInvoiceList',
    feature: 'estimatedInvoices',
    permissionsAny: ['estimatedInvoices:read', 'estimatedInvoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/estimated-invoices/new',
    key: 'keyboardEstimatedInvoiceForm',
    feature: 'estimatedInvoices',
    permissionsAny: ['estimatedInvoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/estimated-invoices/edit/:id',
    key: 'keyboardEstimatedInvoiceForm',
    feature: 'estimatedInvoices',
    permissionsAny: ['estimatedInvoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
  {
    path: '/estimated-invoices/view/:id',
    key: 'keyboardEstimatedInvoiceView',
    feature: 'estimatedInvoices',
    permissionsAny: ['estimatedInvoices:read', 'estimatedInvoices:write'],
    permissionsAll: KEYBOARD_MODE_PERMISSIONS,
  },
];

export const publicRouteDefs = [
  { path: '/landing', key: 'landing', public: true },
  { path: '/login', key: 'login', public: true },
  { path: '/auth/clerk/sign-in/*', key: 'clerkSignIn', public: true },
  { path: '/accept-invitation/*', key: 'acceptInvitation', public: true },
  { path: '/request-portal', key: 'requestPortal', public: true },
  { path: '/email-preferences/unsubscribe', key: 'campaignUnsubscribe', public: true },
  { path: '/campaigns/unsubscribe', key: 'campaignUnsubscribe', public: true },
  { path: '/sample-portal', key: 'samplePortal', public: true },
  { path: '/customer-portal/auth/sign-in/*', key: 'customerPortalAuth', public: true, feature: 'customerPortal' },
  { path: '/admin/login', key: 'adminLogin', public: true },
];
